import React, { Component } from 'react';
import Lightbox from 'react-image-lightbox-universal';

import CarouselThumbnail from './carousel_thumbnail';
import SendOffer from '../send_offer';
import Favourites from '../favourites';

export default class Carousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentImageUrl: this.props.images[0],
      photoIndex: 0,
      isOpen: false,
      visibleThumbnailsCount: props.isOffer ? 4 : 8
    };
  }

  componentDidMount() {
    window.addEventListener('hashchange', this.closeOnBack, false);
  }

  componentWillUnmount() {
    window.removeEventListener('hashchange', this.closeOnBack, false);
  }

  render() {
    const images = this.props.images;
    const thumbnails = this.renderThumbnailsList();
    let mainImgStyle = {
      backgroundImage: `url(${this.state.currentImageUrl})`
    };
    let carouselClass =
      this.props.isOffer == true ? 'carousel horizontal' : 'carousel vertical';
    return (
      <div className={carouselClass}>
        <div
          className="main-image"
          style={mainImgStyle}
          onClick={this.handleZoom}
        >
          <div className="controls">
            <div className="left-arrow" onClick={this.prevImage}>
              <i className="fa fa-chevron-left" aria-hidden="true" />
            </div>
            <div className="right-arrow" onClick={this.nextImage}>
              <i className="fa fa-chevron-right" aria-hidden="true" />
            </div>
            <div className="zoom" onClick={this.handleZoom}>
              <i className="fa fa-neuter" aria-hidden="true" />
            </div>
          </div>
          <div className="action-buttons-wrapper">
            {this.props.isOffer && (
              <SendOffer offer={this.props.offer} token={this.props.token} />
            )}
            {this.props.isOffer && (
              <Favourites offer={this.props.offer} token={this.props.token} />
            )}
          </div>
        </div>
        <div className="thumbnails">{thumbnails}</div>
        {this.state.isOpen && this.openLightbox(images)}
      </div>
    );
  }

  renderThumbnailsList = () => {
    let images = this.props.images;
    let that = this;
    let imagesToShow = images.slice(0, this.state.visibleThumbnailsCount);

    return imagesToShow.map((imgUrl, index) => {
      return (
        <CarouselThumbnail
          key={index}
          imgCount={images.length}
          elemIndex={index}
          imageUrl={imgUrl}
          lastThumbnailIndex={this.state.visibleThumbnailsCount - 1}
          onThumbnailClick={that.handleThumbnailClick}
          onLastThumbnailClick={this.handleLastThumbnailClick}
        />
      );
    });
  };

  openLightbox = images => {
    window.location.hash = 'hotel-gallery';
    let photoIndex = this.state.photoIndex;
    return (
      <Lightbox
        mainSrc={images[photoIndex]}
        nextSrc={images[(photoIndex + 1) % images.length]}
        prevSrc={images[(photoIndex + images.length - 1) % images.length]}
        onCloseRequest={this.closeLightbox}
        onMovePrevRequest={() =>
          this.setState({
            photoIndex: (photoIndex + images.length - 1) % images.length
          })
        }
        onMoveNextRequest={() =>
          this.setState({
            photoIndex: (photoIndex + 1) % images.length
          })
        }
      />
    );
  };

  closeOnBack = () => {
    if (location.hash != '#hotel-gallery') {
      this.setState({ isOpen: false });
    }
  };

  closeLightbox = () => {
    this.setState({ isOpen: false });
    window.history.back();
  };

  prevImage = e => {
    e.stopPropagation();
    let images = this.props.images;
    let prevImageIndex =
      (this.state.photoIndex + images.length - 1) % images.length;
    this.setState({
      photoIndex: prevImageIndex,
      currentImageUrl: images[prevImageIndex]
    });
  };

  nextImage = e => {
    e.stopPropagation();
    let images = this.props.images;
    let nextImageIndex = (this.state.photoIndex + 1) % images.length;
    this.setState({
      photoIndex: nextImageIndex,
      currentImageUrl: images[nextImageIndex]
    });
  };

  handleZoom = e => {
    e.stopPropagation();
    this.setState({ isOpen: true });
  };

  handleLastThumbnailClick = photoIndex => {
    this.setState({
      isOpen: true,
      photoIndex,
      currentImageUrl: this.props.images[photoIndex]
    });
  };

  handleThumbnailClick = event => {
    let photoIndex = parseInt(event.currentTarget.dataset.elementIndex);
    let images = this.props.images;
    this.setState({
      currentImageUrl: images[photoIndex],
      photoIndex: photoIndex
    });
  };
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offer/components/gallery/carousel.jsx